import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'
import { AppBarTheme } from '../../../themeConstants'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    headerContainer: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        width: '100%',
    },
    appBarParent: {
        backgroundColor: 'transparent',
        boxShadow: '0px 2px 3.84px rgba(0, 0, 0, 0.25)',
        elevation: 5,
    },
    appBarParentBenefits: {
        backgroundColor: 'transparent',
        boxShadow: '0px 2px 3.84px rgba(0, 0, 0, 0.25)',
        elevation: 5,
    },
    appBar: {
        paddingHorizontal: 20,
        paddingVertical: 12,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 60,
    },
    appBarLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    appBarRight: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: 1,
    },
    appBarAvatar: {
        width: AppBarTheme.navImageWidth,
        height: AppBarTheme.navImageHeight,
        marginLeft: 10,
        transform: AppBarTheme.navImageTransform,
    },
    arrow: {
        paddingRight: 10,
    },
    menuButton: {
        paddingRight: 10,
        paddingLeft: 5,
    },
    appBarIcons: {
        paddingHorizontal: 8,
        paddingVertical: 4,
        marginLeft: 8,
    },
    wifi: {
        width: 20,
        height: 20,
        marginLeft: 10,
    },
    bell: {
        width: 24,
        height: 24,
    },
})

export default styles
